/**
 * Brand mark for Macaron by Patisse.
 *
 * Uses the client-supplied wordmark image ("MACARON · by Patisse") so the
 * visual matches the client's brand book exactly. Sizes:
 *   sm — sidebar / mobile bar
 *   md — login mobile, invoice header
 *   lg — login hero, print headers
 */
const HEIGHTS = { sm: "h-8", md: "h-12", lg: "h-20 sm:h-24" };

export default function BrandMark({ size = "md", className = "" }) {
  const h = HEIGHTS[size] || HEIGHTS.md;
  return (
    <img
      src="/macaron-by-patisse-logo.png"
      alt="Macaron by Patisse"
      className={`${h} w-auto object-contain ${className}`}
      draggable={false}
    />
  );
}

/**
 * Lockup shown on the Login hero panel — just the wordmark centered.
 */
export function BrandLockup({ className = "" }) {
  return (
    <div className={`inline-flex items-center ${className}`}>
      <img
        src="/macaron-by-patisse-logo.png"
        alt="Macaron by Patisse"
        className="h-24 sm:h-28 w-auto object-contain"
        draggable={false}
      />
    </div>
  );
}
